// Shown without a session: how to get the one-time link from the bot.
import { Chat } from '../icons';
import { useT } from '../i18n';
import { bold } from '../lib/rich';

const DM_URL = 'https://ig.me/m/eat.recipe';

export function SignIn() {
  const t = useT();
  return (
    <div class="page">
      <div style="background:var(--soft);padding:28px 20px 24px;display:flex;flex-direction:column;gap:22px;border-radius:0 0 28px 28px">
        <div class="wordmark">eat<span>.</span>recipe</div>
        <div style="display:flex;flex-direction:column;gap:10px" aria-hidden="true">
          <div style="align-self:flex-end;max-width:70%;padding:10px 14px;border-radius:18px 18px 4px 18px;background:var(--ink);color:var(--ground);font-size:15px;font-weight:600">login</div>
          <div style="align-self:flex-start;max-width:80%;padding:10px 14px;border-radius:18px 18px 18px 4px;background:var(--card);border:1px solid var(--line);font-size:15px;line-height:1.45">{t('signin.bubble')}</div>
        </div>
      </div>
      <div style="padding:26px 20px 0;display:flex;flex-direction:column;gap:8px">
        <h1 class="h1">{t('signin.title')}</h1>
      </div>
      <ol style="margin:0;padding:22px 20px 0;list-style:none;display:flex;flex-direction:column;gap:14px">
        {[bold(t('signin.step1'), { h: '@eat.recipe' }), bold(t('signin.step2'), { w: 'login' }), t('signin.step3')].map((line, i) => (
          <li style="display:flex;gap:14px;align-items:flex-start">
            <span style="flex:none;width:32px;height:32px;border-radius:999px;background:var(--accent);color:var(--on-accent);display:flex;align-items:center;justify-content:center;font-weight:700;font-size:15px">{i + 1}</span>
            <span style="font-size:16px;line-height:1.5;padding-top:4px">
              {line}
            </span>
          </li>
        ))}
      </ol>
      <div style="margin-top:auto;padding:28px 20px 28px;display:flex;flex-direction:column;gap:12px">
        <a class="btn btn-primary" style="height:56px;border-radius:16px;font-size:17px" href={DM_URL}><Chat />{t('signin.message')}</a>
        <div class="muted" style="font-size:14px;text-align:center">{t('signin.have')}</div>
      </div>
    </div>
  );
}
